import React, { Suspense,useEffect } from 'react'
import {
  Redirect,
  Route,
  Switch,
  useHistory,
} from 'react-router-dom'
import { CContainer, CFade } from '@coreui/react'
import { connect,DispatchProp } from 'react-redux'
import { GuardProvider, GuardedRoute } from 'react-router-guards'
import { RouteComponentProps } from 'react-router'
// routes config
import routes from '../routes'
import Websocket from '../socket/Component'
import { State } from '../store'
import { hasPermission } from '../types/user'
import { Permission } from '../types/permissions'
import { loginNeeded,navigated } from '../state/actions'
import Notifications from '../components/Notifications'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

type Props = {
  user:State['auth']['user']
} & DispatchProp

const TheContent : React.FC<Props> = (props) => {
  
  const history = useHistory()

   useEffect(() => {
      let prev = history.location.pathname
      return history.listen((x) => {
        if(prev != x.pathname)
        {
          prev = x.pathname
          props.dispatch(navigated())
        }
      })
   },[history])

  const permissionCheck = (to:any,_from:any,next:any) =>
  {
    if(to.meta.permissions.length)
    {
      if(props.user && to.meta.permissions.find((v:Permission) => hasPermission(props.user!,v)))
      {
        next()
      } else {
        window.location.reload();
        // next.redirect('/leads')
        // next.redirect('/forbidden')
      }
    }
    else
    {
      next()
    }
  }

  const requireUser = (to:any, _from:any, next:any) =>
  {
    if(to.meta.auth)
    {
      if(props.user)
      {
        next()
      } else {
        props.dispatch(loginNeeded(window.location.pathname))
        next.redirect('/login')
      }
    }
    else
    {
      next()
    }
  }

  return (
    <main className="c-main">
      <CContainer fluid>
        <Suspense fallback={loading}>
          <Switch>
            {routes?.length > 0 && routes?.map((route, idx) => {
              return route.component && (
                  <GuardedRoute
                    key={idx}
                    path={route.path}
                    exact={true}
                    meta={ { auth:true,permissions:route.permissions } }
                    guards={ [requireUser,permissionCheck] }
                    component={ (props:RouteComponentProps) => <CFade className="h-100"><route.component {...props }/></CFade> }
                  />
              )
            })}
            <Redirect from="/" to="/leads" />
          </Switch>
          <Websocket />
        </Suspense>
        <Notifications/>
      </CContainer>
    </main>
  )
}
export default connect((state:State) => ({
  user:state.auth.user,
}))(TheContent)
